import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';

import { TextFieldWhite } from '../../../components/customStyles/form';
import { SpanError } from '../../../components/customStyles/form';

import { FormTitle } from './generationFormStyle';

import { GENERATION_FORM_ERROR_MSG } from '../constants';


const CustomProductTitle = ({ generationForm, inputErrorMsg, handleInput }) => {

  return (
    <Box mb={4}>
      <FormTitle variant='h4'>商品描述／其他內容<SpanError>*</SpanError></FormTitle>
      <Box mt={2}>
        <TextFieldWhite
          name="generation_product_title"
          placeholder="描述您的商品"
          value={generationForm.generation_product_title || ""}
          onChange={handleInput}
          multiline
          rows={4}
          maxRows={4}
        />
        {inputErrorMsg?.generationProductTitle &&
          <FormHelperText error>{GENERATION_FORM_ERROR_MSG.generationProductTitle}</FormHelperText>
        }
      </Box>
    </Box>
  )
}

export default CustomProductTitle;